// Insignia de la fuente del anuncio (auktionshaus).
// Zuchlag es agregador: siempre identificamos de dónde viene cada lote.
export default function SourceBadge({ source }) {
  if (!source) return null
  const name = source.name || source.code || 'Quelle'
  return (
    <span className="source-badge" title={`Quelle: ${name}`}>
      <span className="source-dot" aria-hidden="true" />
      {name}
    </span>
  )
}
